import { message, Modal } from "antd";
import { useEffect, useState } from "react";
import {
  DefaultErrorMessage,
  UpdateDataSuccessfully,
} from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import {
  getBranchPaymentSetting,
  updateBranchPaymentSetting,
} from "states/payment-gateway/payment-gateway.api";
import {
  MxMerchantSettingModel,
  PaymentGatewayCodeConst,
  PaymentGatewayModel,
} from "states/payment-gateway/payment-gateway.models";
import { MxmerchantSettingForm } from "./mxmerchant-setting-form";

export interface IBranchPaymentApiModalProps {
  branchId: number;
  paymentGateway?: PaymentGatewayModel;
  show: boolean;
  closeModal: () => void;
}

export function BranchPaymentApiModal(props: IBranchPaymentApiModalProps) {
  const { branchId, show, closeModal, paymentGateway } = props;
  const [apiSetting, setApiSetting] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);

  const _handleCloseModal = () => {
    setApiSetting({});
    closeModal();
  };

  const _handleSaveApiSetting = async () => {
    if (!branchId || !paymentGateway) {
      return;
    }
    setIsLoading(true);
    try {
      await updateBranchPaymentSetting(
        branchId,
        paymentGateway.paymentGatewayCode,
        apiSetting
      );
      setIsLoading(false);
      Modal.success({
        title: "Successfully",
        content: "Cập nhật thành công",
        afterClose: () => {
          _handleCloseModal();
        },
      });
    } catch (error) {
      setIsLoading(false);
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };
  useEffect(() => {
    if (show && branchId && paymentGateway) {
      getBranchPaymentSetting(branchId, paymentGateway.paymentGatewayCode).then(
        (res) => {
          setApiSetting(res.data);
        }
      );
    }
  }, [show, paymentGateway, branchId]);
  return (
    <Modal
      title={
        <div
          style={{
            width: "100%",
            cursor: "move",
          }}
        >
          {`Api Setting ${paymentGateway?.paymentGatewayName}`}
        </div>
      }
      confirmLoading={isLoading}
      centered={true}
      visible={show}
      onOk={_handleSaveApiSetting}
      onCancel={_handleCloseModal}
      okText="Save"
      cancelText="Cancel"
    >
      {branchId &&
        paymentGateway &&
        paymentGateway.paymentGatewayCode ===
          PaymentGatewayCodeConst.MxMerchant && (
          <MxmerchantSettingForm
            model={apiSetting as MxMerchantSettingModel}
            onChange={(newSetting) => {
              setApiSetting(newSetting);
            }}
          />
        )}
    </Modal>
  );
}
